import { useSignal } from "@preact/signals";
import { toast } from "sonner";
import { account, resendVerification } from "~/web/src/auth";

// The unverified account's reminder (spec: docs/project/own-auth-spec.md,
// decision 6), on every page while `verifiedAt` is null: the address the link
// went to, and a Resend. The server's per-minute gap answers the eager click.

export function VerifyBanner() {
  const a = account.value;
  const busy = useSignal(false);
  if (!a || a.verifiedAt !== null) return null;
  async function resend() {
    busy.value = true;
    try {
      const refused = await resendVerification();
      if (refused) toast.error(refused);
      else toast.success(`Sent — check ${a?.email}.`);
    } finally {
      busy.value = false;
    }
  }
  return (
    <div class="verify-banner" role="status">
      <span>
        Verification pending — we've mailed a link to <b>{a.email}</b>. Open it to keep your
        account.
      </span>
      <button
        type="button"
        class="btn ghost sm"
        disabled={busy.value}
        onClick={() => void resend()}
      >
        Resend
      </button>
    </div>
  );
}
